import React from 'react'
import { KTSVG } from '../../../../_metronic/helpers'
import { formatMoney, formatPct, ExpenseAnomalySummary } from '../types'

type Props = {
  summary?: ExpenseAnomalySummary | null
  loading?: boolean
}

type KpiCard = {
  title: string
  value: string
  sub: string
  icon: string
  tone: 'danger' | 'primary' | 'info' | 'warning' | 'cyan'
}

const SummaryCards: React.FC<Props> = ({ summary, loading }) => {
  const s = summary
  const cards: KpiCard[] = [
    {
      title: 'Users with Anomalies',
      value: s ? String(s.usersWithAnomalies) : '—',
      sub: s ? `out of ${s.totalUsersInScope} users` : '',
      icon: '/media/icons/duotune/general/gen044.svg',
      tone: 'danger',
    },
    {
      title: 'Total Anomalies Detected',
      value: s ? String(s.totalAnomaliesDetected) : '—',
      sub: 'across all users',
      icon: '/media/icons/duotune/files/fil005.svg',
      tone: 'primary',
    },
    {
      title: 'Total Anomaly Amount',
      value: s ? formatMoney(s.totalAnomalyAmount) : '—',
      sub: s ? `${Number(s.anomalyAmountPercentOfTotal || 0).toFixed(1)}% of total spend` : '',
      icon: '/media/icons/duotune/finance/fin002.svg',
      tone: 'info',
    },
    {
      title: 'Highest Variance',
      value: s ? formatPct(s.highestVariancePercent) || '—' : '—',
      sub: s?.highestVarianceLabel || '',
      icon: '/media/icons/duotune/arrows/arr016.svg',
      tone: 'warning',
    },
    {
      title: 'Categories with Anomalies',
      value: s ? String(s.categoriesWithAnomalies) : '—',
      sub: s ? `out of ${s.totalCategoriesInScope} categories` : '',
      icon: '/media/icons/duotune/abstract/abs026.svg',
      tone: 'cyan',
    },
  ]

  return (
    <div className='row g-3 mb-4 ss-anomalies-summary-row'>
      {cards.map((c) => (
        <div key={c.title} className='col-12 col-sm-6 col-xl'>
          <div className='card card-flush h-100 ss-anomalies-summary-card'>
            <div className='card-body py-4 px-4'>
              <div className='d-flex align-items-start gap-3'>
                <div className={`ss-anomalies-kpi-icon ss-anomalies-kpi-icon--${c.tone}`}>
                  <KTSVG path={c.icon} className='svg-icon-2' />
                </div>
                <div className='flex-grow-1 min-w-0'>
                  <div className='ss-anomalies-summary-card__title mb-1'>{c.title}</div>
                  {loading ? (
                    <div className='spinner-border spinner-border-sm text-primary' role='status' />
                  ) : (
                    <>
                      <div className='ss-anomalies-summary-card__value mb-1'>{c.value}</div>
                      {c.sub ? <p className='ss-anomalies-summary-card__sub mb-0'>{c.sub}</p> : null}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default SummaryCards
